import LoginPage from "views/User/LoginPage.jsx";
import RegisterPage from "views/User/RegisterPage.jsx";
import VerificationPage from "views/User/VerificationPage.jsx";
import ForgotPasswordPage from "views/User/ForgotPasswordPage.jsx";
import UserProfile from "views/User/UserProfile.jsx";

// @material-ui/icons
import PersonAdd from "@material-ui/icons/PersonAdd";
import Fingerprint from "@material-ui/icons/Fingerprint";

const userRoutes = [
  {
    path: "/register",
    name: "Register Page",
    short: "Register",
    mini: "RP",
    icon: PersonAdd,
    component: RegisterPage
  },
  {
    path: "/login",
    name: "Login Page",
    short: "Login",
    mini: "LP",
    icon: Fingerprint,
    component: LoginPage
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    short: "Forgot Password",
    mini: "FP",
    icon: Fingerprint,
    dontShowInHeader: true,    
    component: ForgotPasswordPage
  },
  {
    path: "/account-verification",
    name: "Verification Page",
    short: "Verification",
    mini: "VP",
    icon: Fingerprint,
    dontShowInHeader: true,    
    component: VerificationPage
  },
  {
    path: "/user/user-page",
    name: "User Profile",
    mini: "UP",
    component: UserProfile
  },  
];


export default userRoutes;



// WEBPACK FOOTER //
// ./src/routes/user.jsx